import Vue from 'vue'
import Vuet from 'vuet'
import VuetRoute from 'vuet-route'

Vuet.rule('route', VuetRoute)
Vue.use(Vuet)

const vuet = new Vuet({
    pathJoin: '/', // 定义模块的连接符
    modules: {
        group: { // 组管理
            data() {
                return {
                    form: {},
                    page: {},
                    isBack: false
                }
            },
            fetch() {
            },
            reset() {
                this.form = {};
                this.page = {};
                this.isBack = false;
            },
            update(page) {
                this.page = page;
                this.isBack = true;
            },
            updateForm(form) {
                this.form = form;
            }
        },
        site: { // 站点管理
            data() {
                return {
                    search: 'simple',
                    form: {},
                    page: {},
                    isBack: false,
                    table:[]
                }
            },
            fetch() {
            },
            reset() {
                this.search = 'simple';
                this.form = {};
                this.page = {};
                // this.table=[]
                this.isBack = false;
            },
            update(page) {
                this.page = page;
                this.isBack = true;
            },
            updateForm(search, form) {
                this.search = search;
                this.form = form;
            },
            updateTable(table){
                this.table=table
            }
        },
        role: { // 角色管理
            data() {
                return {
                    form: {},
                    page: {},
                    isBack: false
                }
            },
            fetch() {
            },
            reset() {
                this.form = {};
                this.page = {};
                this.isBack = false;
            },
            update(page) {
                this.page = page;
                this.isBack = true;
            },
            updateForm(form) {
                this.form = form;
            }
        },
    }
});

export default vuet;


// WEBPACK FOOTER //
// ./src/utils/vuet.js